export const CINEMA_UI_URL = process.env.REACT_APP_CINEMA_UI_URL
export const QW_INBOX_API_URL = process.env.REACT_APP_QW_INBOX_API_URL
export const ZIPPO_URL = process.env.REACT_APP_ZIPPO_URL
export const DEVICE_MANAGER_ROLE = process.env.REACT_APP_DEVICE_MANAGER_ROLE


// WEBPACK FOOTER //
// ./src/app/common/config.js